import styled from '@emotion/styled'

export const Container = styled.div`
  width: 95%;
  margin: 0 auto;
  padding: 20px;
  background: ${({ theme }: any) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid ${({ theme }: any) => theme.colors.borderColor};
`

export const Title = styled.h2`
  font-size: 20px;
  color: ${({ theme }: any) => theme.colors.text};
  margin: 0;
`

export const Summary = styled.div`
  font-size: 14px;
  color: ${({ theme }: any) => theme.colors.textGrey};
`

export const LoadingState = styled.div`
  padding: 40px;
  text-align: center;
  color: ${({ theme }: any) => theme.colors.textGrey};
`

export const EmptyState = styled.div`
  padding: 40px;
  text-align: center;
  color: ${({ theme }: any) => theme.colors.text50};
  font-size: 16px;
`

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

export const Item = styled.li<{ unread?: boolean; theme?: any }>`
  padding: 16px;
  margin-bottom: 12px;
  background: ${({ unread, theme }: any) =>
    unread ? theme.colors.primaryLight : theme.colors.white};
  border-left: 3px solid
    ${({ unread, theme }: any) =>
      unread ? theme.colors.primary : 'transparent'};
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`

export const ItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`

export const ItemTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }: any) => theme.colors.text};
`

export const ItemTime = styled.div`
  font-size: 13px;
  color: ${({ theme }: any) => theme.colors.textGrey};
  display: flex;
  align-items: center;
  gap: 6px;
`

export const UnreadBadge = styled.div`
  width: 8px;
  height: 8px;
  background: ${({ theme }: any) => theme.colors.primary};
  border-radius: 50%;
`

export const ItemBody = styled.div`
  font-size: 14px;
  color: ${({ theme }: any) => theme.colors.textGrey};
  margin-bottom: 12px;
`

export const ItemMeta = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
  margin-bottom: 12px;
  padding: 10px;
  background: ${({ theme }: any) => theme.colors.brown50};
  border-radius: 4px;
`

export const MetaItem = styled.div`
  font-size: 13px;
  color: ${({ theme }: any) => theme.colors.textGrey};

  span {
    font-weight: 500;
    color: ${({ theme }: any) => theme.colors.text};
  }
`

export const ItemFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
`

export const ItemDate = styled.div`
  font-size: 12px;
  color: ${({ theme }: any) => theme.colors.text50};
`

export const MarkReadButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: 1px solid ${({ theme }: any) => theme.colors.borderColor};
  color: ${({ theme }: any) => theme.colors.textGrey};
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${({ theme }: any) => theme.colors.brown50};
    border-color: ${({ theme }: any) => theme.colors.inputBorder};
  }
`

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid ${({ theme }: any) => theme.colors.borderColor};
`

export const PaginationButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid ${({ theme }: any) => theme.colors.borderColor};
  background: ${({ theme }: any) => theme.colors.white};
  color: ${({ theme }: any) => theme.colors.text};
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: ${({ theme }: any) => theme.colors.brown50};
    border-color: ${({ theme }: any) => theme.colors.inputBorder};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const PageInfo = styled.div`
  font-size: 14px;
  color: ${({ theme }: any) => theme.colors.textGrey};
`
